import { History } from 'history';
import { Consumer as C, createContext } from 'react';

export const context = createContext<History>({} as History);

export const Provider = context.Provider;
export const Consumer = context.Consumer as C<History>;
